import { baseClient } from "./baseRequest";

export type ArtistsBrief = {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  labels: string[];
  active: boolean;
};

export type ArtistsBriefSubmission = {
  selectedCardIds: string[];
  selectedBriefTitles: string[];
  fullName: string;
  email: string;
  portfolioUrl: string;
  message: string | null;
  createdAt?: string;
};

export type ArtistsBriefsApiClient = {
  getBriefs: () => Promise<ArtistsBrief[]>;
  saveBriefs: (briefs: ArtistsBrief[]) => Promise<void>;
  getSubmissions: () => Promise<ArtistsBriefSubmission[]>;
};

const artistsBriefsClient: ArtistsBriefsApiClient = {
  getBriefs: async () => {
    return baseClient.get<ArtistsBrief[]>({ url: "/admin/artists-briefs" });
  },
  saveBriefs: async (briefs) => {
    return baseClient.put({
      url: "/admin/artists-briefs",
      body: { cards: briefs },
    });
  },
  getSubmissions: async () => {
    return baseClient.get<ArtistsBriefSubmission[]>({
      url: "/admin/artists-briefs/submissions",
    });
  },
};

export default artistsBriefsClient;
